import { Fab } from "@material-ui/core";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import AddIcon from "@material-ui/icons/Add";
// custom
import EventsList from "components/EventsList";
import FormEvent from "components/FormEvent";
// reactor
import Page from "components/Page";
// constants
import { EVENT } from "constants/routes";
import { updateURLParameter } from "helpers";
import PropTypes from "prop-types";
import React from "react";
// styles
import styles from "./styles";

class WrapperEventPage extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    refresh: PropTypes.func,
    urlParams: PropTypes.object,
    history: PropTypes.object,
    loading: PropTypes.bool,
    events: PropTypes.array,
    createEvent: PropTypes.func,
    deleteEvent: PropTypes.func,
    updateEvent: PropTypes.func,
  };

  constructor(...args) {
    super(...args);
    const { urlParams } = this.props;
    this.state = {
      index: urlParams.index ? Number(urlParams.index) : 0,
      selectedEvent: undefined,
      formEventOpen: false,
    };
  }

  getStepContent() {
    const { index } = this.state;
    const { events, history } = this.props;

    switch (index) {
      case 0:
        return (
          <EventsList
            events={events}
            onSelect={(e) => history.push(`${EVENT}?id=${e.id}`)}
          />
        );
      default:
    }

    return [];
  }

  render() {
    const {
      classes,
      history,
      loading,
      createEvent,
      deleteEvent,
      updateEvent,
      refresh,
    } = this.props;

    const { index, selectedEvent, formEventOpen } = this.state;

    return (
      <Page
        helmet="Events"
        loading={loading}
        fab={
          <Fab
            color="primary"
            aria-label="Add"
            onClick={() => this.setState({ formEventOpen: true })}
          >
            <AddIcon />
          </Fab>
        }
        loadingMessage={"Fetching all Events"}
        tabs={
          <Tabs
            value={index}
            onChange={(e, v) => {
              this.setState({ index: v });
              history.push({
                search: updateURLParameter("index", v),
              });
            }}
            indicatorColor="primary"
            textColor="primary"
            scrollable
            scrollButtons="auto"
            classes={{
              root: classes.tabsRoot,
              indicator: classes.tabsIndicator,
            }}
          >
            <Tab
              label="All"
              classes={{
                root: classes.tabRoot,
                selected: classes.tabSelected,
              }}
            />
          </Tabs>
        }
      >
        {this.getStepContent()}
        <FormEvent
          open={formEventOpen}
          event={selectedEvent}
          close={() => {
            this.setState({
              formEventOpen: false,
            });
            setTimeout(
              () =>
                this.setState({
                  selectedEvent: undefined,
                }),
              200
            );
          }}
          createEvent={createEvent}
          deleteEvent={deleteEvent}
          updateEvent={updateEvent}
          refresh={refresh}
        />
      </Page>
    );
  }
}
export default withStyles(styles)(WrapperEventPage);
